import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Eye, EyeSlash } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin({ onSuccess }) {
  const [tokenInput, setTokenInput] = useState("");
  const [showToken, setShowToken] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState("");

  const onLogin = async (e) => {
    e.preventDefault();
    const t = tokenInput.trim();
    if (!t || loggingIn) return;
    setLoggingIn(true);
    setLoginError("");
    try {
      const r = await fetch(`${BACKEND}/api/admin/stats`, { headers: { "X-Admin-Token": t } });
      if (r.status === 401 || r.status === 403) {
        setLoginError("Invalid admin token — check and try again.");
        setLoggingIn(false);
        return;
      }
      if (!r.ok) {
        setLoginError(`Login failed (HTTP ${r.status}). Try again in a moment.`);
        setLoggingIn(false);
        return;
      }
      onSuccess(t);
      setTokenInput("");
    } catch (err) {
      setLoginError(`Network error: ${err?.message || "unreachable"}`);
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <main data-testid="admin-login" className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6 font-body">
      <form onSubmit={onLogin} className="w-full max-w-md border border-white/10 bg-[#0F0F0F] p-8 space-y-5">
        <Link to="/" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/50 hover:text-[#FF1B91] mb-4">
          <ArrowLeft size={14} weight="bold" /> Back to site
        </Link>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#FF1B91] font-semibold">Admin / Locked</div>
        <h1 className="font-display font-black uppercase text-3xl tracking-tighter">Sweat With Slay <span className="text-[#FF1B91]">·</span> Admin</h1>
        <label className="block">
          <span className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-semibold">Admin token</span>
          <div className="relative mt-2">
            <input
              data-testid="admin-token-input"
              type={showToken ? "text" : "password"}
              value={tokenInput}
              onChange={(e) => setTokenInput(e.target.value)}
              className="w-full bg-black border border-white/15 px-4 py-3 pr-12 text-white focus:border-[#FF1B91] outline-none"
              placeholder="Paste admin token"
              required
              autoFocus
            />
            <button type="button" onClick={() => setShowToken(!showToken)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[#FF1B91]">
              {showToken ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
            </button>
          </div>
        </label>
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loggingIn}
          className="w-full bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loggingIn ? "Verifying…" : "Unlock dashboard"}
        </button>
        {loginError && (
          <div data-testid="admin-login-error" className="text-[11px] uppercase tracking-[0.2em] text-red-400 border border-red-500/40 bg-red-500/5 px-3 py-2">
            {loginError}
          </div>
        )}
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/30">Token set via backend env var ADMIN_TOKEN.</p>
      </form>
    </main>
  );
}
